import React from 'react'

const VideoInfo: React.FC = () => {
  return (
    <div className="min-h-screen bg-background p-4">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-center gap-3 mb-8">
          <img
            src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
            alt="Athios Logo"
            className="w-10 h-10"
          />
          <h1 className="text-2xl font-bold text-foreground">Athios - Earn from Organic Posts</h1>
        </div>

        <div className="bg-black/30 backdrop-blur-xs rounded-xl p-6 border border-foreground/10">
          <div className="max-w-md mx-auto">
            <div className="aspect-9/16 rounded-lg overflow-hidden bg-black">
              <video
                controls
                className="w-full h-full object-contain"
                poster="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
              >
                <source
                  src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_earn_organic_posts.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-foreground/80 text-lg mb-4">
              Discover how Athios helps athletes monetize their organic social media content
            </p>
            <p className="text-foreground/60 text-sm">
              Learn more about our platform and how you can start earning from your posts today.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoInfo
